"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function AndroidGreyOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "#6C757D",
    clipPath: "url(#prefix__android-grey-outline__clip0_19514_5324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.573 12.273a1.135 1.135 0 000 2.26.841.841 0 00.69-.322v.14a.145.145 0 00.141.14h.34v-2.166h-.466v.275a.84.84 0 00-.691-.327h-.014zm.089.444a.7.7 0 010 1.4.66.66 0 01-.64-.69.645.645 0 01.64-.71zM3.417 14.491a.135.135 0 01-.135-.14v-2.026h.467v.266a.767.767 0 01.654-.318.812.812 0 01.826.831v1.401h-.336a.15.15 0 01-.15-.15v-1.143a.467.467 0 00-.466-.495.588.588 0 00-.542.625v1.15h-.318zM6.653 12.273a1.135 1.135 0 000 2.26.827.827 0 00.686-.322v.14a.15.15 0 00.14.14h.346v-3.268h-.467v1.358a.827.827 0 00-.686-.326l-.02.018zm.084.444a.7.7 0 110 1.4.652.652 0 01-.635-.69.644.644 0 01.635-.71zM8.497 14.491a.137.137 0 01-.13-.085.136.136 0 01-.01-.055v-2.026h.467v.355a.597.597 0 01.584-.383c.057-.005.115-.005.173 0v.5a.797.797 0 00-.234-.038.57.57 0 00-.523.62v1.094l-.327.018zM12.536 14.491a.135.135 0 01-.14-.14v-2.026h.467v2.166h-.327zM14.301 12.273a1.135 1.135 0 000 2.26.827.827 0 00.705-.322v.14a.15.15 0 00.14.14h.327v-3.268h-.467v1.358a.837.837 0 00-.686-.326l-.019.018zm.084.444a.7.7 0 010 1.4.652.652 0 01-.635-.69.644.644 0 01.635-.71zM12.634 11.858a.322.322 0 100-.645.322.322 0 000 .645zM10.874 12.273a1.114 1.114 0 00-1.13 1.13 1.106 1.106 0 001.13 1.144 1.13 1.13 0 100-2.26v-.014zm0 .467a.682.682 0 11-.644.687.653.653 0 01.644-.687z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.093 1.067a.467.467 0 01.64.16L5.135 3.56a.467.467 0 01-.8.48L2.933 1.708a.467.467 0 01.16-.64zM10.564 4.202a.467.467 0 00.64-.16l1.401-2.335a.467.467 0 10-.8-.48L10.402 3.56a.467.467 0 00.16.641z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.109 5.232c1.276-1.397 3.185-2.458 5.893-2.458 2.661 0 4.561 1.138 5.839 2.556 1.264 1.404 1.921 3.081 2.145 4.22a.74.74 0 01-.73.882H.745A.742.742 0 01.01 9.57C.222 8.3.848 6.613 2.11 5.232zm-.904 4.08h13.572a8.282 8.282 0 00-1.769-3.232c-1.095-1.215-2.704-2.185-5.006-2.185-2.38 0-3.993.919-5.066 2.093-.947 1.037-1.486 2.29-1.73 3.323z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.57,
    cy: 6.837,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.434,
    cy: 6.837,
    r: 0.7
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__android-grey-outline__clip0_19514_5324"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

AndroidGreyOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
AndroidGreyOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = AndroidGreyOutline;
exports["default"] = _default;